'use client'

import { Skeleton } from '@/components/ui/skeleton'
import ChampionshipCardMulti from './championship-card-multi'
import ChampionshipCardSingle from './championship-card-single'

export default function ChampionshipCard({
  championship: championshipObject,
  championshipId: _championshipId,
  communityId: _communityId,
}) {
  const championship = championshipObject

  if (!championship) {
    return <Skeleton className="h-[787px] w-full" />
  }

  if (championship.isSingleEvent)
    return <ChampionshipCardSingle championship={championship} />
  return <ChampionshipCardMulti championship={championship} />
}
